import { GET_ALL_PEOPLE, GET_FEATURE_FLAGS } from './query'

export const getAllPeople = async (client, args = {}) => {
  const { data } = await client.query({
    query: GET_ALL_PEOPLE,
    variables: args,
  })
  return data.getAllPeople
}

export const getFeatureFlags = async client => {
  const { data } = await client.query({
    query: GET_FEATURE_FLAGS,
  })
  return data.getFeatureFlags
}
